import React from 'react';
import { CommonReadonly, TitleSearchDisplayNameFullHTML } from '@warehouse/title/core';
import { GridColDef } from '@mui/x-data-grid-pro';
import ChipDisplay from '../../../../src/components/library/ChipDisplay';
import { getCustomGridSingleSelectOperators } from '../../../shared/ui/table/muix.adapter';
import editUseJson from '../../../../src/assets/json-administration-profiles/editUse.json';
import editClassJson from '../../../../src/assets/json-administration-profiles/editClass.json';
import countriesJson from '../../../../src/assets/json-administration-profiles/availableCountry.json';

export function EditUseColumnDataGrid<T extends CommonReadonly>(): GridColDef<T, string> {
	return {
		headerName: 'Edit Use',
		editable: false,
		field: 'editUse',
		valueOptions: editUseJson,
		minWidth: 110,
		renderCell: (params) => params.row.titleSearchDisplayNameFullHTML.editUse,
		type: 'singleSelect',
		filterOperators: getCustomGridSingleSelectOperators(),
	};
}

export function EditClassesColumnDataGrid<T extends CommonReadonly>(): GridColDef<T, string[]> {
	return {
		headerName: 'Edit Classes ',
		editable: false,
		field: 'editClasses',
		minWidth: 200,
		renderCell: (params) => {
			// Calculate available width for ChipDisplay
			const padding = 80; // Account for cell padding
			const availableWidth = params.colDef.computedWidth ? params.colDef.computedWidth - padding : 180;

			return (
				<div style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
					<ChipDisplay
						allowOverflow
						width={availableWidth}
						variant="default"
						horizontalPadding={0}
						values={params.row.titleSearchDisplayNameFullHTML.editClasses || []}
						height={26}
					/>
				</div>
			);
		},
		valueOptions: editClassJson,
		type: 'singleSelect',
		filterOperators: getCustomGridSingleSelectOperators(),
		resizable: true,
	};
}

export function EditDescriptionColumnDataGrid<T extends CommonReadonly>(): GridColDef<T, string> {
	return {
		headerName: 'Edit Description',
		editable: false,
		field: 'editDescription',
		minWidth: 200,
		renderCell: (params) => params.row.descriptions?.[0]?.description,
		resizable: true,
	};
}

export function MadeForRegionsColumnDataGrid<T extends CommonReadonly>(): GridColDef<
	T,
	TitleSearchDisplayNameFullHTML | undefined
> {
	return {
		headerName: 'Made For Regions',
		field: 'madeForRegions',
		editable: false,
		minWidth: 250,
		renderCell: (params) => {
			const titleSearchDisplayNameFullHTML = params.row?.titleSearchDisplayNameFullHTML;
			const regionsToDisplay = titleSearchDisplayNameFullHTML?.madeForRegions
				? titleSearchDisplayNameFullHTML?.madeForRegions
				: titleSearchDisplayNameFullHTML?.madeForRegionsExclude;

			// Calculate available width for ChipDisplay
			const padding = 100; // Account for cell padding
			const availableWidth = params.colDef.computedWidth ? params.colDef.computedWidth - padding : 180;

			return (
				<div style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
					{titleSearchDisplayNameFullHTML?.madeForRegionsExclude ? 'Excl. ' : ''}
					<div style={{ marginLeft: titleSearchDisplayNameFullHTML?.madeForRegionsExclude ? '8px' : undefined }}>
						<ChipDisplay
							allowOverflow
							variant="default"
							horizontalPadding={0}
							width={availableWidth}
							values={regionsToDisplay || []}
							height={26}
						/>
					</div>
				</div>
			);
		},
		valueOptions: countriesJson,
		type: 'singleSelect',
		resizable: true,
	};
}
